import { useEffect, useState } from 'react';

import { fetchBudgetFailureModes, fetchBudgetServices } from '../../../../api/fetchBudget';

interface IDetailServiceHeaderProps {
  serviceId: string;
  failureModeId?: string;
  serviceIndex: number;
}

const DetailServiceHeader = (props: IDetailServiceHeaderProps) => {
  const [serviceName, setServiceName] = useState<string>('');
  const [failureModeName, setFailureModeName] = useState<string>('');

  useEffect(() => {
    const loadServiceData = async () => {
      if (props.serviceId) {
        try {
          const services = await fetchBudgetServices();
          const service = services.find((s) => s.id === props.serviceId);
          if (service) {
            setServiceName(service.label);
          }

          if (props.failureModeId && props.serviceId) {
            const failureModes = await fetchBudgetFailureModes(props.serviceId);
            const failureMode = failureModes.find((fm) => fm.id === props.failureModeId);
            if (failureMode) {
              setFailureModeName(failureMode.label);
            }
          }
        } catch (error) {
        }
      }
    };

    loadServiceData();
  }, [props.serviceId, props.failureModeId]);

  const getHeaderColor = (index: number): string => {
    return index % 2 === 0 ? 'bg-blue-50' : 'bg-gray-50';
  };

  if (!serviceName && !failureModeName) return null;
  return (
    <div
      className={`${getHeaderColor(
        props.serviceIndex,
      )} p-3 rounded-md mb-4 flex flex-row justify-between items-center`}
    >
      {serviceName && (
        <div className="font-bold text-size-16">{serviceName || 'Serviço'}</div>
      )}
      {failureModeName && (
        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded text-size-12 font-bold">
          {failureModeName}
        </span>
      )}
    </div>
  );
};

export default DetailServiceHeader;
